module.exports = __webpack_public_path__ + "img/bg_block.8259e923.png";